import React from 'react';
import { useLocation, useNavigate } from 'react-router-dom';
import Tab from '../../tabs/tabs';
import CampBillings from './campBillings/CampBillings';
import CampPayouts from './campPayouts/CampPayouts';

const OrgCampBillings = () => {
    const navigate = useNavigate();
    const location = useLocation();
    // the open tab comes from the URL (/org/c/billing or /org/c/payouts)
    const activeTab = location.pathname.startsWith('/org/c/payouts') ? 'Payouts' : 'Billing';

    const handleTabChange = (tab) => {
        if (tab === activeTab) return;
        navigate(
            tab === 'Billing' ? '/org/c/billing?page=1' : '/org/c/payouts?page=1'
        );
    };
    return (
        <>
            <div className='tabContainer bookingSticky'>
                <Tab label='Billing' value='Billing' activeTab={activeTab} setActiveTab={handleTabChange} />
                <Tab label='Payouts' value='Payouts' activeTab={activeTab} setActiveTab={handleTabChange} />
            </div>
            <div>
                {activeTab === 'Billing' && <CampBillings />}
                {activeTab === 'Payouts' && <CampPayouts />}
            </div>
        </>
    );
};

export default OrgCampBillings;
